import { render, staticRenderFns } from "./LineAltVIcon.vue?vue&type=template&id=736547a1&"
import script from "./LineAltVIcon.vue?vue&type=script&lang=js&"
export * from "./LineAltVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports